import { Session } from "./components/session";
import { useEffect, useState } from "react";
import { fetchQuestionSet } from "./data";
import { SocketContext, useWebsocket } from "./websocket";
const DEBATLAB_URL = import.meta.env.VITE_DEBATLAB_URL;
const QUESTION_SET_ID = import.meta.env.VITE_DEBATLAB_QID;

export default function App() {
  const [questionSet, setQuestionSet] = useState(null);
  const websocket = useWebsocket();

  useEffect(() => {
    // If we are in development AND both variables are not set, we return the dummy data
    const returnDummyData =
      import.meta.env.DEV &&
      DEBATLAB_URL === undefined &&
      QUESTION_SET_ID === undefined;

    fetchQuestionSet(DEBATLAB_URL, QUESTION_SET_ID, { returnDummyData }).then(
      setQuestionSet,
    );
  }, []);

  if (questionSet === null) {
    return <div className="spinner"></div>;
  }

  return (
    <SocketContext.Provider value={websocket}>
      <Session questionSet={questionSet} />
    </SocketContext.Provider>
  );
}
